import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useQuotationDescriptionsList() {
  // Use toast
  const toast = useToast();

  const refQuotationDescriptionListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "sort_order", label: "排序", sortable: true , class: "sticky-column"},
    { key: "actions", label: "操作", class: "sticky-column" },
    { key: "name", label: "標題", sortable: true },
    { key: "description", label: "內容", sortable: true, class: 'pre-wrap mw-300' },
    { key: "is_active", label: "狀態", sortable: true },
    { key: "updated_at", label: "修改日期", sortable: true },
    { key: "created_at", label: "創建日期", sortable: true },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const quotationDescriptionsList = ref(null);


  const dataMeta = computed(() => {
    const localItemsCount = refQuotationDescriptionListTable.value
      ? refQuotationDescriptionListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refQuotationDescriptionListTable.value.refresh();
  };

  watch(
    [
      currentPage, perPage, searchQuery, 
    ],
    () => {
      refetchData();
    }
  );

  const fetchQuotationDescriptions = (ctx, callback) => {

    store
      .dispatch("quotation-description/fetchQuotationDescriptions", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then((response) => {
        const { quotation_descriptions, total } = response.data;
        callback(quotation_descriptions);
        totalRow.value = total;
        quotationDescriptionsList.value = quotation_descriptions
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取印章清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  onMounted(() => {
  });

  return {
    fetchQuotationDescriptions,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    quotationDescriptionsList,
    refQuotationDescriptionListTable,
    ability,
    refetchData,
  };
}
